import { render } from "./KUniverseCard.vue?vue&type=template&id=ef850f36&scoped=true"
import script from "./KUniverseCard.vue?vue&type=script&lang=js"
export * from "./KUniverseCard.vue?vue&type=script&lang=js"

import "./KUniverseCard.vue?vue&type=style&index=0&id=ef850f36&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef850f36"]])

export default __exports__